const initRoiCalculatorReturningUserVisibility = require("./initRoiCalculatorReturningUserVisibility");
const listenToFirstRoiGateFormCountryFieldUpdate = require("./listenToFirstRoiGateFormCountryFieldUpdate");
const listenToFirstRoiGateFormFirstNameFieldUpdate = require("./listenToFirstRoiGateFormFirstNameFieldUpdate");
const listenToFirstRoiGateFormLastNameFieldUpdate = require("./listenToFirstRoiGateFormLastNameFieldUpdate");
const listenToFirstRoiGateFormCompanyFieldUpdate = require("./listenToFirstRoiGateFormCompanyFieldUpdate");
const listenToRoiGateFormSubmission = require("./listenToRoiGateFormSubmission");
const getRoiCalculatorIframe = require("./getRoiCalculatorIframe");
const waitUntilRoiCalculatorAngularDomIsRendered = require("./waitUntilRoiCalculatorAngularDomIsRendered");
const listenToRoiCalculatorFormUpdatedEvent = require("./listenToRoiCalculatorFormUpdatedEvent");
const listenToRoiCalculatorFormSubmittedEvent = require("./listenToRoiCalculatorFormSubmittedEvent");
const listenToRoiCalculatorOutputUrlEvent = require("./listenToRoiCalculatorOutputUrlEvent");
const listenToRoiCalculatorOutputFailedEvent = require("./listenToRoiCalculatorOutputFailedEvent");
const listenToRoiCalculatorTopDownloadPdfButtonClick = require("./listenToRoiCalculatorTopDownloadPdfButtonClick");
const listenToRoiCalculatorBottomDownloadPdfButtonClick = require("./listenToRoiCalculatorBottomDownloadPdfButtonClick");
const listenToRoiCalculatorReturningUserNotYouButtonClick = require("../roiCalculator/listenToRoiCalculatorReturningUserNotYouButtonClick");
const listenToRoiCalculatorReturningUserCtaClicks = require("../roiCalculator/listenToRoiCalculatorReturningUserCtaClicks");
const showRoiCalculatorGateContent = require("./showRoiCalculatorGateContent");

/**
 * @typedef {{
 *     onFirstRoiGateFormCountryFieldUpdate: () => void,
 *     onFirstRoiGateFormFirstNameFieldUpdate: () => void,
 *     onFirstRoiGateFormLastNameFieldUpdate: () => void,
 *     onFirstRoiGateFormCompanyFieldUpdate: () => void,
 *     onRoiGateFormSubmit: (form: HTMLFormElement) => void,
 *     onRoiCalculatorFormUpdatedEvent: (calculatorData: RoiCalculatorFormData) => void,
 *     onRoiCalculatorFormSubmittedEvent: (roiCalculatorDocument: Document, calculatorData: RoiCalculatorFormData) => void,
 *     onRoiCalculatorOutputUrlEvent: (outputUrl: string) => void,
 *     onRoiCalculatorOutputFailedEvent: () => void,
 *     onRoiCalculatorTopDownloadPdfButtonClicked: () => void,
 *     onRoiCalculatorBottomDownloadPdfButtonClicked: () => void,
 *     onReturningUserCtaClick: (cta: HTMLElement, marketoFormId: string) => void,
 *     onReturningUserNotYouClick: () => void,
 * }} InitRoiCalculatorArgs
 */

/**
 * @param args {InitRoiCalculatorArgs}
 * @return {Promise<void>}
 */
module.exports = async function initRoiCalculator(args) {
    initRoiCalculatorReturningUserVisibility();

    listenToRoiCalculatorReturningUserNotYouButtonClick(args.onReturningUserNotYouClick);

    listenToRoiCalculatorReturningUserCtaClicks(args.onReturningUserCtaClick);

    listenToFirstRoiGateFormCountryFieldUpdate(args.onFirstRoiGateFormCompanyFieldUpdate);

    listenToFirstRoiGateFormFirstNameFieldUpdate(args.onFirstRoiGateFormFirstNameFieldUpdate);

    listenToFirstRoiGateFormLastNameFieldUpdate(args.onFirstRoiGateFormLastNameFieldUpdate);

    listenToFirstRoiGateFormCompanyFieldUpdate(args.onFirstRoiGateFormCompanyFieldUpdate);

    listenToRoiGateFormSubmission(args.onRoiGateFormSubmit);

    const roiCalculatorIframe = getRoiCalculatorIframe();
    if (roiCalculatorIframe) {
        const roiCalculatorDocument = roiCalculatorIframe.contentWindow.document;

        await waitUntilRoiCalculatorAngularDomIsRendered(roiCalculatorDocument);

        showRoiCalculatorGateContent();

        listenToRoiCalculatorFormUpdatedEvent(roiCalculatorDocument, args.onRoiCalculatorFormUpdatedEvent);

        listenToRoiCalculatorFormSubmittedEvent(
            roiCalculatorDocument,
            (calculatorData) => args.onRoiCalculatorFormSubmittedEvent(roiCalculatorDocument, calculatorData)
        );

        listenToRoiCalculatorOutputUrlEvent(roiCalculatorDocument, args.onRoiCalculatorOutputUrlEvent);

        listenToRoiCalculatorOutputFailedEvent(roiCalculatorDocument, args.onRoiCalculatorOutputFailedEvent);

        listenToRoiCalculatorTopDownloadPdfButtonClick(roiCalculatorDocument, args.onRoiCalculatorTopDownloadPdfButtonClicked);

        listenToRoiCalculatorBottomDownloadPdfButtonClick(roiCalculatorDocument, args.onRoiCalculatorBottomDownloadPdfButtonClicked);
    }
}